/* ew-engine-family.js — THE engine-family normaliser. One implementation.
   ============================================================================
   R2 2.1. Before this file there were NINE copies of this function: four in
   assets/ (ew-vehicle-resolver, ew-chassis-picker, ew-tune-builder,
   ew-use-case-prompt) and five inline "early-paint mirrors" in Liquid sections
   (header, my-garage, main-account, shop-by-vehicle, tuning-stage-hub).

   They existed for a real reason, not carelessness: ew-vehicle-resolver.js is
   loaded by vehicle-data-island near the END of layout/theme.liquid, so with
   `defer` it executes AFTER every consumer. Nothing upstream could call it.

   They drifted, and the drift shipped: ew-use-case-prompt.js carried no
   ENGINE_ALIAS, so B46 cars keyed PREGUESS_MAP as 'B46:G20' — absent from the
   map — and silently fell through to the 'street' default. 38 of 162 chassis
   rows (25 chassis codes) carry a B46/N26 code, and 23 of the 24 'B48:' keys
   in that map are exactly those cars.

   ⛔ THIS FILE IS LOADED WITHOUT `defer`, ON PURPOSE.
   The five Liquid mirrors are bare IIFEs that run at PARSE time, before any
   deferred script. A deferred module here would not exist when they run and
   the mirrors would have to come back. It is ~400 bytes, same-origin, on an
   already-open connection. Do not "optimise" it to defer/async.

   ⛔ NO TU-STRIPPING. /[BNS]\d\d/ takes the FIRST family token, so N63TU2 →
   N63, S63TU → S63, B48B20O1 → B48 already. A separate TU rule is dead code.

   DISPLAY + MATCHING both use this. It never mutates a stored engine_code.

   One contract, two runtimes: the Liquid arm of this same contract lives in
   snippets/ew-bundle-cover.liquid. Change one, change the other, and keep
   test/fixtures/engine-family.json passing for both.
   ========================================================================= */
(function (w) {
  'use strict';

  /* B46 is the emissions-variant sibling of B48; N26 of N20. Same tune target,
     so they fold to the parent family for every lookup. */
  var ALIAS = { B46: 'B48', N26: 'N20' };

  function engineFamily(raw) {
    var s = String(raw == null ? '' : raw).toUpperCase().trim();
    var m = s.match(/[BNS]\d\d/);
    var fam = m ? m[0] : s;
    return ALIAS[fam] || fam;
  }

  engineFamily.ALIAS = ALIAS;
  w.EWEngineFamily = engineFamily;
})(window);
